import React from 'react';

/**
 * Selector de 1 a 5 estrellas. Botones grandes (se usa con el celular en la
 * mano) y radiogroup accesible para lectores de pantalla.
 */

interface EstrellasInputProps {
  value: number;
  onChange: (value: number) => void;
}

export const Estrella: React.FC<{ llena: boolean; size?: number }> = ({ llena, size = 32 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" aria-hidden="true">
    <path
      d="M12 3.5l2.6 5.3 5.9.9-4.3 4.1 1 5.8-5.2-2.7-5.2 2.7 1-5.8-4.3-4.1 5.9-.9L12 3.5z"
      fill={llena ? '#D9A441' : 'none'}
      stroke={llena ? '#D9A441' : 'currentColor'}
      strokeWidth={1.6}
      strokeLinejoin="round"
    />
  </svg>
);

const EstrellasInput: React.FC<EstrellasInputProps> = ({ value, onChange }) => (
  <div role="radiogroup" aria-label="Calificación de 1 a 5 estrellas" className="flex gap-1 text-sage">
    {[1, 2, 3, 4, 5].map((n) => (
      <button
        key={n}
        type="button"
        role="radio"
        aria-checked={value === n}
        aria-label={`${n} ${n === 1 ? 'estrella' : 'estrellas'}`}
        onClick={() => onChange(n)}
        className="rounded-md p-1 transition-transform hover:scale-110 focus:outline-none focus-visible:ring-2 focus-visible:ring-forest"
      >
        <Estrella llena={n <= value} />
      </button>
    ))}
  </div>
);

export default EstrellasInput;
